import React, {createContext} from 'react';
const UserOrganisationContext = createContext(null);
export {UserOrganisationContext};